import { gql } from '@apollo/client'

const ADD_NEW_LEAD_STAGE = gql`
  mutation ADD_NEW_LEAD_STAGE(
    $generatedID: ID!
    $name: String!
    $color: String!
    $users: [ID!]!
    $requireReject: Boolean
    $dueDays: Int
  ) {
    addNewLeadStage(
      generatedID: $generatedID
      name: $name
      color: $color
      users: $users
      requireReject: $requireReject
      dueDays: $dueDays
    ) {
      id
      name
      color
      requireReject
      dueDays
      users {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default ADD_NEW_LEAD_STAGE
